import Language from "@bimproject/language";
import styled from "styled-components";

import Flag from "../../images-icons/Flag";

export default function LanguageLabel(props: LocaleLabelProps) {
    const { language, ...restProps } = props;
    return (
        <Styled
            data-language={ language }
            { ...restProps }
        >
            <Flag code={ Language.fromCode(language).countryCode } />
            <div>
                <span>{ Language.fromCode(language).nativeName }</span>
                <span>{ Language.fromCode(language).name }</span>
            </div>
        </Styled>
    );
}

interface LocaleLabelProps {
    language: string
}

const Styled = styled.div`
    align-items: center;
    display: flex;
    flex-direction: row;
    gap: 8px;

    & > div {
        align-items: flex-start;
        cursor: default;
        display: flex;
        flex-direction: column;
        gap: 2px;
        white-space: nowrap;

        span {
            display: block;
            font-size: .8rem;
            line-height: .9;

            &:empty {
                display: none;
            }

            &:not(:first-of-type) {
                opacity: .6;
            }
        }
    }
`;
